import { render, staticRenderFns } from "./DataCheckerErrorDisplayer.vue?vue&type=template&id=60f18c98&"
import script from "./DataCheckerErrorDisplayer.vue?vue&type=script&lang=js&"
export * from "./DataCheckerErrorDisplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports